import { render, staticRenderFns } from "./CustomizeMetalH.vue?vue&type=template&id=7c857866&scoped=true"
import script from "./CustomizeMetalH.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalH.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalH.vue?vue&type=style&index=0&id=7c857866&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c857866",
  null
  
)

export default component.exports